import { CompactTable, useAssetTranslation } from '@mss/mss-component-library';
import React from 'react';
import dateFormat from 'dateformat';
import { useHistory } from 'react-router-dom';

const RemoteSessionCompactTable = ({ resources, loading }: any) => {
  const { t } = useAssetTranslation();
  const remoteSessionRoute = '/sessions/sessions/{ID}/details';
  const history = useHistory();

  return (
    <CompactTable
      bordered={false}
      dataSource={resources}
      onRow={(record: any) => ({
        onClick: () => {
          history.push(remoteSessionRoute.replace('{ID}', record.id));
        },
      })}
      loading={loading}
      columns={[
        {
          title: t('User'),
          dataIndex: ['user_object', 'name'],
          key: 'user_name',
          width: 165,
          sorter: (a: any, b: any) =>
            a.user_object?.name?.toUpperCase() >
            b.user_object?.name?.toUpperCase()
              ? 1
              : -1,
        },
        {
          title: t('Target asset',{ns:'remoteAccess'}),
          dataIndex: ['asset_object', 'name'],
          key: 'asset_name',
          defaultSortOrder: 'ascend',
          sorter: (a: any, b: any) =>
            a.asset_object?.name?.toUpperCase() >
            b.asset_object?.name?.toUpperCase()
              ? 1
              : -1,
        },
        {
          title: t('Protocol'),
          dataIndex: 'protocol',
          key: 'protocol',
          width: 50,
          sorter: (a: any, b: any) =>
            a.protocol?.toUpperCase() > b.protocol?.toUpperCase() ? 1 : -1,
          render: (protocol: string) => <>{protocol?.toUpperCase()}</>,
        },
        {
          title: t('Request date',{ns:'remoteAccess'}),
          dataIndex: 'created_at',
          key: 'created_at',
          width: 165,
          sorter: (a: any, b: any) =>
            a.created_at?.toUpperCase() > b.created_at?.toUpperCase() ? 1 : -1,
          render: (record: any) =>
            record && dateFormat(record || '', 'mmmm dS, yyyy @ h:MM:ss TT'),
        },
        {
          title: t('Last Activity',{ns:'remoteAccess'}),
          dataIndex: 'last_activity',
          key: 'last_activity',
          width: 165,
          sorter: (a: any, b: any) =>
            a.last_activity?.toUpperCase() > b.last_activity?.toUpperCase()
              ? 1
              : -1,
          render: (record: any) =>
            record && dateFormat(record || '', 'mmmm dS, yyyy @ h:MM:ss TT'),
        },
      ]}
      rowKey={'id'}
    />
  );
};

export default RemoteSessionCompactTable;
